import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'

import { createPortalContainer } from 'utils/createPortalContainer'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  className?: string
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, className = '' }) => {
  const [container] = React.useState(createPortalContainer)

  useEffect(() => {
    document.body.appendChild(container)
    return () => {
      document.body.removeChild(container)
    }
  }, [container])

  useEffect(() => {
    if (!isOpen) return
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [isOpen])

  if (!isOpen) return null

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]" onClick={onClose}>
      <div className={className} onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    container,
  )
}
